import React from 'react';

import type { RouteObject } from 'react-router-dom';

import Pages from '@/pages';

import { UserPermissions } from '@components/Permissions/userPermission';

const MeteringPointInformation = React.lazy(
  () => import('@/pages/MeteringPointDetails/views/Information'),
);
const MeteringPointNodes = React.lazy(() => import('@/pages/Nodes'));
const MeteringNodeInformation = React.lazy(
  () => import('@/pages/NodeDetails/views/Information'),
);
const MeteringNodeSeal = React.lazy(() => import('@/pages/Seal'));
const SealDetails = React.lazy(() => import('@/forms/MeteringNodeSealForm'));

const MeteringDevices = React.lazy(() => import('@/pages/Devices'));

const CommercialMeteringPointEquipment = React.lazy(
  () =>
    import('@/pages/CommercialMeteringPointDetails/views/GasConsumingEquipment'),
);

const GasConsumingEquipmentFormView = React.lazy(
  () => import('@/pages/CommercialMeteringPointDetails/views/Form'),
);

const MeteringModemDetails = React.lazy(
  () => import('@/forms/MeteringModemForm'),
);
const MeteringDeviceDetails = React.lazy(
  () => import('@/forms/MeteringDeviceForm/MeteringDeviceFormPreviewMode'),
);

const MeteringPointActs = React.lazy(() => import('@/pages/MeteringPointActs'));

// TODO: move to Pages in case if this needed
export const MeteringPointsChildrenPath = {
  METERING_POINT_ACTS: 'metering-point-acts',
  METERING_NODE: 'metering-nodes',
  METERING_NODE_SEAL: 'seals',
  DEVICES: 'devices',
  MODEMS: 'modems',
};

export const meteringPointsRoutes: RouteObject[] = [
  {
    element: <MeteringPointInformation />,
    index: true,
  },
  {
    path: MeteringPointsChildrenPath.METERING_POINT_ACTS,
    element: <MeteringPointActs />,
    handle: {
      permissions: UserPermissions.GasDistributionStationMeteringPointActRead,
    },
  },
  {
    // Вузел обліку газу  ВОГ / GasMeteringNode
    path: MeteringPointsChildrenPath.METERING_NODE,
    element: <MeteringPointNodes />,
    handle: {
      permissions: UserPermissions.GasDistributionStationGasMeteringNodeRead,
    },
  },
  {
    path: MeteringPointsChildrenPath.METERING_NODE_SEAL,
    element: <MeteringNodeSeal />,
    children: [{ path: ':sealId', element: <SealDetails /> }],
    handle: {
      permissions: UserPermissions.GasDistributionStationSealRead,
    },
  },
  {
    path: Pages.DEVICES,
    element: <MeteringDevices />,
    children: [
      {
        path: MeteringPointsChildrenPath.MODEMS + '/:modemId',
        element: <MeteringModemDetails />,
      },
      {
        path: ':deviceId',
        element: <MeteringDeviceDetails />,
      },
    ],
    handle: {
      permissions: UserPermissions.GasDistributionStationMeteringDeviceRead,
    },
  },
  {
    path: `${Pages.EQUIPMENT}`,
    element: <CommercialMeteringPointEquipment />,
    children: [
      {
        path: ':gasConsumingEquipmentId',
        element: <GasConsumingEquipmentFormView />,
      },
    ],
    handle: {
      permissions:
        UserPermissions.GasDistributionStationGasConsumingEquipmentRead,
    },
  },
];

export const meteringPointsNodeRoutes: RouteObject[] = [
  {
    index: true,
    element: <MeteringNodeInformation />,
  },
  {
    path: Pages.DEVICES,
    element: <MeteringDevices />,
    children: [
      {
        path: MeteringPointsChildrenPath.MODEMS + '/:modemId',
        element: <MeteringModemDetails />,
      },
      {
        path: ':deviceId',
        element: <MeteringDeviceDetails />,
      },
    ],
  },
  {
    path: `${Pages.EQUIPMENT}`,
    element: <CommercialMeteringPointEquipment />,
    children: [
      {
        path: ':gasConsumingEquipmentId',
        element: <GasConsumingEquipmentFormView />,
      },
    ],
  },
];
